import { on } from 'delegated-events'

const actionBar = document.querySelector('.mobile-action-bar')

const fn = {
  init: () => {
    on('click', '[data-mab-trigger]', fn.handleOpenOverlay)
    on('click', '.mobile-action-bar-close button', fn.handleCloseOverlay)

    window.addEventListener('scroll', fn.handleScroll)
    window.addEventListener('resize', fn.setViewportHeight)

    fn.setViewportHeight()
    fn.handleScroll()
    fn.setupMapEmbed()
  },

  handleOpenOverlay: (e) => {
    const target = document.getElementById(e.target.closest('[data-mab-trigger]').dataset.mabTrigger)

    if (target) {
      actionBar.classList.add('is-overlay-active')
      target.classList.add('is-active')
      document.documentElement.classList.add('overflow-hidden')
    }
  },

  handleCloseOverlay: () => {
    actionBar.classList.remove('is-overlay-active')
    document.documentElement.classList.remove('overflow-hidden')
    document.querySelectorAll('.mobile-action-bar-overlay.is-active').forEach((x) => x.classList.remove('is-active'))
  },

  handleScroll: () => {
    document.documentElement.classList.toggle('has-scrolled', window.pageYOffset > 0)
  },

  setViewportHeight: () => {
    const height =
      window.innerHeight && document.documentElement.clientHeight
        ? Math.min(window.innerHeight, document.documentElement.clientHeight)
        : window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName('body')[0].clientHeight

    document.documentElement.style.setProperty('--vh', `${height}px`)
  },

  setupMapEmbed: () => {
    const mapHolder = document.getElementById('mobile-action-bar-map-embed')

    if (!mapHolder) {
      return
    }

    const google = window.google
    const data = JSON.parse(mapHolder.dataset.json)
    const center = new google.maps.LatLng(data.lat, data.lng)

    const mapOptions = {
      center,
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    }

    const map = new google.maps.Map(mapHolder, mapOptions)
    const bounds = new google.maps.LatLngBounds()

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      const marker = new google.maps.Marker({
        map: map,
        title: data.title,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(data.lat, data.lng),
        panposition: new google.maps.LatLng(data.lat, data.lng),
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open(data.mapLink)
      })

      bounds.extend(marker.getPosition())
    })
  },
}

export default {
  can: () => actionBar,
  run: fn.init,
}
